var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentDots = function SvgCommentDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5v18h5v5.078L14.352 23H29V5Zm2 2h22v14H13.648L10 23.918V21H5Zm5 5a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4m6 0a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4m6 0a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4"
  })));
};
export default SvgCommentDots;